import { Stack } from '@mantine/core';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { isStandalone } from '~portal/lib';
import { SsrComponent } from '~portal/lib/SsrComponent';

export const Route = createFileRoute('/_protected/insights/')({
  beforeLoad: () => {
    if (isStandalone) {
      throw redirect({ to: '/chat/$conversationId', params: { conversationId: 'new' } });
    }
  },
  component: InsightsPage,
});

function InsightsPage() {
  return (
    <Stack gap="lg" p="lg">
      <SsrComponent path="/fragments/operators" label="Insights" />
    </Stack>
  );
}
